"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidatedRedirectUrl = void 0;
var getValidatedRedirectUrl = function (currentOrigin, redirectUrl, defaultRedirectUrl) {
    if (defaultRedirectUrl === void 0) { defaultRedirectUrl = '/'; }
    var fullDefaultRedirectUrl = new URL(defaultRedirectUrl, currentOrigin)
        .href;
    if (typeof redirectUrl !== 'string')
        return fullDefaultRedirectUrl;
    var cleanRedirectUrl = decodeURIComponent(redirectUrl.replace(/\s+/g, ''));
    var url = new URL(cleanRedirectUrl, currentOrigin);
    if (url.hostname.match(/\.(angi|angieslist)\.com$/) ||
        new URL(currentOrigin).hostname === url.hostname)
        return url.href;
    return fullDefaultRedirectUrl;
};
exports.getValidatedRedirectUrl = getValidatedRedirectUrl;
exports.default = exports.getValidatedRedirectUrl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0VmFsaWRhdGVkUmVkaXJlY3RVcmwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZ2V0VmFsaWRhdGVkUmVkaXJlY3RVcmwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQU8sSUFBTSx1QkFBdUIsR0FBRyxVQUNyQyxhQUFxQixFQUNyQixXQUFvQixFQUNwQixrQkFBd0I7SUFBeEIsbUNBQUEsRUFBQSx3QkFBd0I7SUFFeEIsSUFBTSxzQkFBc0IsR0FBRyxJQUFJLEdBQUcsQ0FBQyxrQkFBa0IsRUFBRSxhQUFhLENBQUM7U0FDdEUsSUFBSSxDQUFDO0lBRVIsSUFBSSxPQUFPLFdBQVcsS0FBSyxRQUFRO1FBQUUsT0FBTyxzQkFBc0IsQ0FBQztJQUVuRSxJQUFNLGdCQUFnQixHQUFHLGtCQUFrQixDQUFDLFdBQVcsQ0FBQyxPQUFPLENBQUMsTUFBTSxFQUFFLEVBQUUsQ0FBQyxDQUFDLENBQUM7SUFDN0UsSUFBTSxHQUFHLEdBQUcsSUFBSSxHQUFHLENBQUMsZ0JBQWdCLEVBQUUsYUFBYSxDQUFDLENBQUM7SUFFckQsSUFDRSxHQUFHLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQywyQkFBMkIsQ0FBQztRQUMvQyxJQUFJLEdBQUcsQ0FBQyxhQUFhLENBQUMsQ0FBQyxRQUFRLEtBQUssR0FBRyxDQUFDLFFBQVE7UUFFaEQsT0FBTyxHQUFHLENBQUMsSUFBSSxDQUFDO0lBRWxCLE9BQU8sc0JBQXNCLENBQUM7QUFDaEMsQ0FBQyxDQUFDO0FBcEJXLFFBQUEsdUJBQXVCLDJCQW9CbEM7QUFDRixrQkFBZSwrQkFBdUIsQ0FBQyJ9


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/auth-redirect-router/getValidatedRedirectUrl.js
// module id = 2110
// module chunks = 25